import React from "react";
import { FadeLoader } from "react-spinners";
import StackKit from "../stack";
type SpinnerType = {
  color?: string;
  sx?: any;
};
const SpinnerKit = (props: SpinnerType) => {
  const { color, ...sx } = props;
  return (
    <StackKit
      sx={{ width: "100%" }}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <FadeLoader color={color} />
    </StackKit>
  );
};

export default SpinnerKit;
